import * as Yup from 'yup';

import { ScheduledMessageByUid } from 'models/automation/ScheduledMessages';
import {
  MessagingType,
  SystemTemplate,
} from 'models/automation/SystemTemplates';
import { LanguageCode } from 'i18n/internationalization.types';

export const scheduledMessagesEditModalSchema = ({
  messagingType,
}: {
  messagingType?: MessagingType;
}) =>
  Yup.object({
    templateContent: Yup.string().richTextEditorContentRequired(),
    templateContent_htmlContent: Yup.string().required(),
    templateSubject: Yup.string().when({
      is: () => messagingType === MessagingType.EMAIL,
      then: (schema) => schema.required(),
    }),
  });

export type ScheduledMessagesEditModalFormValues = Yup.InferType<
  ReturnType<typeof scheduledMessagesEditModalSchema>
>;

export const getFormDefaultValues = ({
  scheduledMessage,
  template,
}: {
  scheduledMessage: ScheduledMessageByUid;
  template?: SystemTemplate | null;
}): ScheduledMessagesEditModalFormValues => {
  const language =
    scheduledMessage.template?.templateLanguage ?? LanguageCode.EN;
  const templateContent =
    scheduledMessage.template?.templateContent ??
    template?.locales?.[language]?.content;
  const templateSubject =
    scheduledMessage.template?.templateTitle ??
    template?.locales?.[language]?.subject;

  return {
    templateContent: templateContent ?? '',
    templateContent_htmlContent: templateContent ?? '',
    templateSubject: templateSubject ?? '',
  };
};
